
import { combineReducers } from 'redux'
//import { connectRouter } from 'connected-react-router' // xt this syncs react router with redux
//import { routerReducer} from 'redux-first-history' //  this is wrong now t-router
//import { createReduxHistoryContext } from 'redux-first-history';
// Your reducers
import agencyStubs from './agencyStubs'
import agency from './agency'
import reportSummaries from './reportSummaries'
import responderLocations from './responderLocations'
import report from './report'
import modal from './modal'
import messages from './messages'
import predefinedMessages from './predefinedMessages'
import internalMessages from './internalMessages'
import profile from './profile'
import reportCSV from './csvReports'
import errorReducer from './errorReducerNew'

// TEST OF IMPORT EERROR.. FROM CHAT
try {
  const initState = errorReducer(undefined, { type: '@@INIT' });
  console.log('Test error reducer initial state:', initState);
  if (typeof initState === 'undefined') {
    console.error('❌ Error reducer returns undefined on init');
  }
} catch (e) {
  console.error('❌ Error reducer threw:', e);
}

/// end of test

console.log('reducer/index file error reducer source:', errorReducer.toString());
// Now test the reducer function:
console.log('reducer/index file Error reducer function:', errorReducer);
console.log('reducer/index file Error reducer(undefined, {type: "@@INIT"}):', errorReducer(undefined, {type: '@@INIT'}));

console.log('in reducers/index line 26 error reducer imported:', errorReducer);
Object.entries({ agencyStubs, agency, reportSummaries, responderLocations, report, modal, messages, predefinedMessages, internalMessages, profile, reportCSV, errorReducer }).forEach(([key, reducer]) => {
  console.log(`Checking reducer "${key}"...`);
  if (typeof reducer !== 'function') {
    console.error(`❌ Reducer "${key}" is NOT a function:`, reducer);
  } else {
    console.log(" in the reducers/index at line 35, the else ")
    try {
      const testState = reducer(undefined, { type: '@@INIT' });
      if (typeof testState === 'undefined') {
        console.error(`❌ Reducer "${key}" returned undefined on INIT (bad)`);
      } else {
        console.log(`✅ Reducer "${key}" passed INIT check`);
      }
    } catch (err) {
      console.error(`❌ Reducer "${key}" threw error on INIT:`, err);
    }
  }
});
export default function createRootReducer() {
  return combineReducers({
    agencyStubs,
    agency,
    reportSummaries,
    responderLocations,
    report,
    modal,
    messages,
    predefinedMessages,
    internalMessages,
    profile,
    error: errorReducer,
    reportCSV,
  });
}

  
